import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Navbar = ({ content, centerContent }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    const companyDetails = (() => {
        try {
            return JSON.parse(localStorage.getItem("companyDetails") || "{}") || {};
        } catch (e) {
            return {};
        }
    })();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <>
            <nav className="navSection px-3 py-2" ref={wrapperRef} style={{ position: 'relative' }}>
                <div className="d-flex align-items-center gap-2">
                    <div
                        className="image_block d-flex align-items-center justify-content-center"
                        onClick={() => {
                            navigate(-1);
                        }}
                        style={{ cursor: "pointer", fontSize: "1.5rem", height: "100%" }}
                    >
                        <span style={{ lineHeight: 1 }}>←</span>
                    </div>
                    <h4 className="navbar_heading mb-0">{content}</h4>
                </div>
                {centerContent && (
                    <div className="navbar_center_content">
                        {centerContent}
                    </div>
                )}
                <div className="image_block" style={{ fontSize: "1.2rem", position: 'relative' }}>
                    <button
                        type="button"
                        className="btn btn-sm btn-light rounded-circle"
                        onClick={() => setOpen(!open)}
                        aria-expanded={open}
                        aria-haspopup="true"
                    >
                        <span role="img" aria-label="profile">👤</span>
                    </button>

                    {open && (
                        <div className="dropdown-menu show p-3 shadow" style={{ minWidth: 260, right: 0, left: 'auto', position: 'absolute', top: '110%' }}>
                            <div className="mb-2 d-flex align-items-center gap-2">
                                <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" className="bi bi-person-fill" viewBox="0 0 16 16">
                                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="fw-bold">{companyDetails?.name || companyDetails?.ownerName || 'Unknown User'}</div>
                                    <div className="small text-muted">{companyDetails?.role || companyDetails?.type || ''}</div>
                                </div>
                            </div>

                            <div className="mb-2">
                                <div className="small text-muted">Email</div>
                                <div className="fw-semibold">{companyDetails?.emailId || companyDetails?.email || '-'}</div>
                            </div>
                            <div className="mb-2">
                                <div className="small text-muted">Mobile</div>
                                <div className="fw-semibold">{companyDetails?.mobileNumber || companyDetails?.alternateMobileNo || '-'}</div>
                            </div>
                            <div className="mb-2">
                                <div className="small text-muted">Role</div>
                                <div className="fw-semibold">{companyDetails?.role || '-'}</div>
                            </div>

                            <div className="d-flex justify-content-end mt-3">
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => setOpen(false)}>Close</button>
                            </div>
                        </div>
                    )}
                </div>
            </nav>
        </>
    );
};

export default Navbar;
